import { render } from "./DocumentClassFieldsLayoutView.vue?vue&type=template&id=01dad3a6&scoped=true&ts=true"
import script from "./DocumentClassFieldsLayoutView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassFieldsLayoutView.vue?vue&type=script&lang=ts"

import "./DocumentClassFieldsLayoutView.vue?vue&type=style&index=0&id=01dad3a6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01dad3a6"]])

export default __exports__